export const VAT_FALLBACK = 0.23;
